// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#signaturename[data-v-680eb4bc] {\r\n  font-weight: bold;\r\n  font-size: 1.2rem;\n}\n[dir] #signaturename[data-v-680eb4bc] {\r\n  text-align: center;\n}\n#signature[data-v-680eb4bc] {\r\n  width: 100%;\r\n  height: 0.5px;\n}\n[dir] #signature[data-v-680eb4bc] {\r\n  border: 0px;\r\n  border-bottom: 0.5px solid black;\n}\r\n", ""]);
// Exports
module.exports = exports;
